import React, { useEffect, useState } from 'react';
import './toggleButton.scss';

interface IToggleProps {
    toggled: boolean;
    onClick: Function;
}
const ToggleButton = ({ toggled, onClick }: IToggleProps): JSX.Element => {
    const [selected, setSelected] = useState<boolean>(toggled);

    useEffect(() => {
        setSelected(toggled);
    }, [toggled]);

    const buttonToggle = (e: boolean) => {
        onClick(e);
    };
    return (
        <div className="squareToggleComponent">
            <div
                onClick={() => {
                    setSelected(true);
                    buttonToggle(true);
                }}
                className={`leftToggle  ${selected ? 'selected' : ''}`}
            >
                적용
            </div>
            <div
                onClick={() => {
                    setSelected(false);
                    buttonToggle(false);
                }}
                className={`rightToggle  ${!selected ? 'selected' : ''}`}
            >
                미적용
            </div>
        </div>
    );
};

export default ToggleButton;
